import OrderAction from './orderAction';
import { isValidEmail } from './utils';

export default class SendInvoice extends OrderAction {
    static NAME = 'send_invoice';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    static condition(order) {
        return (
            ['valid', 'reservation'].includes(order.status) &&
            order.price_ticket !== 0 &&
            order.attendee_count > order.attendees_deleted_count &&
            isValidEmail(order.buyer_email) &&
            order.origin !== 'weez_invitation' &&
            order.invoice !== null
        );
    }

    static is_available({ feature_flags, event }) {
        return !feature_flags.includes('EO_APPR') && !feature_flags.includes('EO_FREE') && !event.removed;
    }

    get needs_selection() {
        return false;
    }

    get needs_confirm() {
        return true;
    }
}
